/**
 * Resolución de URL del logo institucional (misma lógica que Login / HospitalBrandingPanel).
 */
export function resolveHospitalLogoUrl(logoUrl) {
  if (
    logoUrl === null ||
    logoUrl === undefined ||
    String(logoUrl).trim() === ""
  ) {
    return null;
  }
  const s = String(logoUrl).trim();
  if (
    s.startsWith("http://") ||
    s.startsWith("https://") ||
    s.startsWith("data:") ||
    s.startsWith("blob:")
  ) {
    return s;
  }
  const base = process.env.BASE_URL || "/";
  const path = s.startsWith("/") ? s.slice(1) : s;
  const baseNorm = base.endsWith("/") ? base : `${base}/`;
  return `${baseNorm}${path}`;
}

/** v-img a veces no pinta bien data:/blob:; img nativo es más fiable. */
export function hospitalLogoUsesNativeImg(resolvedUrl) {
  const u = resolvedUrl;
  return (
    typeof u === "string" && (u.startsWith("data:") || u.startsWith("blob:"))
  );
}
